/**可选项类型断言 */
export interface Options {
    value: string | number,
    label: string,
}
export interface ValueOptions {
    [test: string]: Array<Options>
}
/** 筛选行表单项 */
export interface FormItem {
    /** filterType 
     * 为1时表示当前筛选项为指标,而指标决定当前筛选行中的 值 是input/select/section(区间)/category(品类选择)
     * 为2时表示条件
     * 为3时表示值
     * 为4时表示按钮
    */
    filterType: number,
    /** value 当前元素的值 例如input的输入值 select的选中值 */
    value?: number | string,
    /** type 指标和条件的项元素类型 目前这两项默认为select*/
    type: string,
    /** options 当前项为select时的选项数据 */
    options?: Array<Options>,
    /** 指标的dom类型 根据指标的变化与要求而确定 */
    valueType?: string
    /** 值的dom类型(valueType)为区间(section)时,其最小值的绑定对象 */
    min?: string,
    /** 值的dom类型(valueType)为区间(section)时,其最大值的绑定对象 */
    max?: string
}
export interface HeardButtons {
    /** 按钮类型  imary / success / warning / danger / info /text*/
    type: string,
    /**按钮文案 */
    text: string,
    /** 当前的操作类型,可以自定义 */
    operation: number,
    /** 当前按钮是否开启按钮禁用操作 */
    isDisabled?: boolean
}
/** 计划备货表格表头和列的属性 */
export interface RestockTableHeader {
    id?: number
    /** 表格对应显示的表格数据值 */
    prop: string,
    /**表头说明tooltip文案 */
    headerToolTip?:string,
    /** 搜索(filterCol)组件专用的查询字段传值定义 */
    searchProp?: string,
    /** 表格对应列的表头文案 */
    label: string,
    /** 表格对应显示的表格数据值后面是否接百分比数据 且百分比数据对应的字段是什么 */
    percent?: string,
    /** 表格对应列的宽度 传了按照width的值设置行宽,不传则自适应 */
    width?: string | number,
    /**列是否固定在左侧或者右侧。值可以为true / 'left' / 'right' 
     * true 表示固定在左侧 */
    fixed?: boolean | string,
    /** 对应列是否可以排序，可设置为true / false / 'custom',
     *  如果设置为 'custom'，则代表用户希望远程排序(后端接口返回)，需要监听 Table 的 sort-change 事件  */
    sortable?: string,
    /** 当前列点击编辑icon按钮时 是否自定义事件处理 传了该值为true 就表示需要自定义事件的处理逻辑,不用组件内部的逻辑
     *  而是在组件共享(emit)出去的editClick事件中进行处理
     */
    customEvent?: boolean
    /** 当前列 是否为操作行,需要单独进行颜色的显示 */
    isOperation?: boolean
    /**当前列 是否需要针对不同数字进行颜色的区分显示 大于0显示红色 小于零显示绿色 等于零为默认黑色 */
    isNumberColor?: boolean
    /** 自定义单元格文案的颜色 */
    color?: string,
    /** 当前列单元格 操作按钮的数组 */
    buttons?: Array<HeardButtons>
    /** 当前列是否显示 的开关,在进行column设置时   */
    columnsValue?: boolean
    /** 当前列是否进行展示的开关是否禁用 */
    columnsDisabled?: boolean
    /** 表格显示内容类型  详细类型请参考typeText枚举        */
    type?: typeText,
    /** 是否可以作为筛选组件的筛选行 */
    isSearch?: boolean,
     /** 表格显示内容为小数点类型,保留的小数点位数  不定义默认为为 1    */
     decimalsNum?: string,
}

/** 按钮接口类型断言  */
export interface buttonType {
    /** 按钮文案 */
    value: string,
    /** 作为按钮事件的判断 该值可以自己定义值 */
    operation: string | number
    /**按钮类型 primary / success / warning / danger / info*/
    type?: string,
}
/** 表格数据除接口返回的数据外,可能需要用到的数据项 主要控制单元格的数据及相关属性 */
export interface tableRests {
    /** 接口返回数据 */
    [label: string]: any
    /** 开关开启状态 1为开启 0为关闭,RestockTableHeader 中的isShowSwitch为true时才会有开关 */
    onOff?: number
    /** 当前开关是否禁用 */
    offDisabled?: boolean
    /** 当前单元格是显示可编辑图标按钮 ps:配合RestockTableHeard中的type为'partEdit'进行使用 */
    isEdit?: boolean
    /**当前单元格按钮是否禁用 必要条件:HeardButtons按钮接口中的isDisabled为true*/
    buttonDisabled?: boolean
    /** 当前单元格是否显示按钮 true表示不显示 false表示显示  注:其中所指的按钮不包含edit的icon图标按钮*/
    notShowButton?: boolean
}
/**搜索组件(filterCol组件) 决定指标dom类型 对象参数说明  */
export interface ChangeObjParams {
   /** 指标dom为 input 输入值需要为字符串 */
    strArr: Array<string>,
   /** 指标dom为 select选择器 */
   selectArr: Array<string>,
   /** 指标dom为 数值区间  */
   sectionArr: Array<string>,
   /** 指标dom为 数值区间,且输入值只保留一位小数,需和sectionArr搭配使用(sectionArr和aDecimalArr中都存在该元素时才生效)  */
   aDecimalArr: Array<string>,
   /** 指标dom为 input,输入值 可用逗号隔开输入多个  */
   commaArr: Array<string>,
   /** 指标dom为 联级(品类)选择器   */
   categoryArr: Array<string>,
   /** 指标dom为 日期选择器   */
   dateRangeArr: Array<string>,
}
/* 搜索组件(filterCol组件) 联机选择器 的prop */
export interface CascderProp {
    multiple: boolean,
    emitPath: boolean,
    value: string,
    label: string,
    children: string,
    [test: string]: any,
    }
export enum restockStore {
    /** 发货方式列表 */
    restock_shipping = 'shippingTypeList',
    /** 仓库列表 */
    restock_warehouse = 'warehouseList',
    /** 邀请渠道等数据*/
    restock_maps = 'mapsList',
    /** 开放的国家列表*/
    region_list = 'regionList',
}

export enum typeText {
    /**textIcon:文案和按钮同时显示 */
    textIcon = 'textIcon',
    /**button:按钮 */
    button = 'button',
    /**edit:编辑图标按钮 */
    edit = 'edit',
    /**img:图片 */
    img = 'img',
    /**switch:开关 */
    switch = 'switch',
    /**isGo:是否可跳转 跳转到详情页 不省略显示*/
    isGo = 'isGo',
    /**text:纯文本 */
    text = 'text',
    /**input:纯输入框 数字 */
    input = 'input',
    /** 部分单元格显示编辑图标按钮 tableRests中的isEdit配合使用 */
    partEdit = 'partEdit',
    /** 部分单元格显示编辑图标按钮及文案 tableRests中的isEdit配合可单独控制是否显示编辑图标按钮 */
    partTextEdit = 'partTextEdit',
    /** 当前单元格内容是否进行国际化  */
    interpret = 'interpret',
    /** 当前单元显示的内容是否显示为千分位格式 */
    thousands = 'thousands',
    /** 当前单元显示的内容保留RestockTableHeader下decimalsNum位小数 */
    decimals = 'decimals',
    /** 当前单元格是否换行显示 鼠标放上去会提示全部内容 */
    ellipsis = 'ellipsis',
    /** goAndEllipsis 较长的文案,需要换行且需要进行跳转商详页 */
    goAndEllipsis = 'goAndEllipsis',
    /** 时间戳日期格式化 */
    time = 'time',
    /** 直接显示日期 */
    timeString = 'timeString',
    /** 自定义表格的显示内容 */
    customize = 'customize',
    /** 表格显示内容 保留 RestockTableHeader下decimalsNum 位数的后几位数 例如: 2,000.00 */
    thousandsDecimals= 'thousandsDecimals',
    /** 表格显示内容 做千分位处理,且保留 RestockTableHeader下decimalsNum 位数,并显示 %  例如: 2,000.00% */
    percentDecimals= 'percentDecimals',

}
// 筛选组件的不同的条件可以决定的值的dom类型
export enum FilterValueType {
    input = 'input',
    /** 选择器 */
    select = 'select',
    /** 区间 */
    section = 'section',
    /** 品类选择器/联级选择*/
    category = 'category',
    /** 日期时间段选择*/
    dateRange = 'dateRange',
}
/** 表格表头标题枚举 */
export enum LabelText {
    skuId = 'SKU ID',
    productName = 'Product Name',
    storeName = 'Store Name',
    ratings = 'Ratings',
    price = 'Price (KSh)',
    warehouse = 'Warehouse',
    warehouseID = 'Warehouse ID',
    proposal = 'Proposal Qty',
    proposalValueKSh = 'Proposal Value (KSh)',
    proposalValue = 'Proposal Value',
    inventory = 'Inventory',
    inTransit = 'In-Transit',
    netSent = 'Net Sent',
    netSent30 = 'Net Sent R30',
    netSent90 = 'Net Sent R90',
    image = 'Image',
    onOff = 'Off/On',
    status = 'Status',
    storeId = 'Store Id',
    sellerProposal = 'Seller Proposal?',
    sellerRegion = 'Seller Region',
    category = 'Category',
    proposalWarehouse = 'Proposal Warehouse',
    gapQty = 'GAP Qty',
    gapValue = 'GAP Value(KSh)',
    restockQty = 'Restock Qty',
    restockValue = 'Restock Value (KSh)',
    approvedRestockQty = 'Approved Restock Qty',
    approvedRestockValueKSh = 'Approved Restock Value (KSh)',
    adminOperate = 'Admin Operate',
    remarks = 'Remarks',
    affordableQty = 'Affordable Qty',
    unappliedQty = 'Unapplied Qty',
    appliedQty = 'Applied Qty',
    appliedValueKSh = 'Applied Value (KSh)',
    appliedQtyRestock = 'Applied Qty (% of Restock Qty)',
    dispatchedQtyRestock = 'Dispatched Qty (% of Restock Qty)',
    dispatchedQty = 'Dispatched Qty',
    dispatchedValue = 'Dispatched Value (KSh)',
    arrivedQtyRestock = 'Arrived Qty (% of Restock Qty)',
    arrivedQty = 'Arrived Qty',
    arrivedValue = 'Arrived Value (KSh)',
    related = 'Related Restock Applications',
    productID = 'Product ID ',
    affordableValue = 'Affordable Value (KSh)',
    operate = 'Operate',
    applyQty = 'Apply Qty',
    adjustedProposalQty = 'Adjusted Proposal Qty',
    adjustedProposalValue = 'Adjusted Proposal Value',
    approvedQty = 'Approved Qty',
    approvedValue = 'Approved Value',
    WSKU = 'WSKU',
    aftersaleRate = 'Aftersale Rate',
    createAt = 'Create At',
    firstListedAt = 'First Listed At',
    storeStatus = 'Store Status',
    storeType = 'Store Type',
    firstSoldAt = 'First Sold At',
    restockable = 'Restockable',
    productStatus = 'Product Status',
    algorithmProposalQty = 'Algorithm Proposal Qty',
    algorithmProposalValue = 'Algorithm Proposal Value',
    salesObjProposalQty = 'Sales Obj. Proposal Qty',
    salesObjProposalValue= 'Sales Obj. Proposal Value',
    currentInventory = 'Current Inventory',
    l1Sales = 'L1 Sales',
    l1InStockDays = 'L1  In-Stock Days',
    l1DailySales = 'L1 Daily Sales',
    l2Sales = 'L2 Sales',
    l2InStockDays = 'L2 In-Stock Days',
    l2DailySales = 'L2 Daily Sales',
    l3Sales = 'L3 Sales',
    l3InStockDays = 'L3 In-Stock Days',
    l3DailySales = 'L3 Daily Sales',
    yoySales = 'YoY Sales',
    yoyInStockDays = 'YoY In-Stock Days',
    yoyDailySales = 'YoY Daily Sales',
    r30Sales = 'R30 Sales',
    r30InStockDays = 'R30 In-Stock Days',
    r30DailySales = 'R30 Daily Sales',
    r90Sales = 'R90 Sales',
    r90InStockDays = 'R90 In-Stock Days',
    r90DailySales = 'R90 Daily Sales',
    r90Visits = 'R90 Visits',
    r90cvr = 'R90 CVR',
    AFSR = 'AFSR',
    AFSRbySeller = 'AFSR by Seller',
    salesProposal = 'Sales Proposal',
    beginningInventoryByAlgorithm = 'Beginning Inventory by Algorithm',
    beginningInventoryBySalesObj = 'Beginning Inventory by Sales Obj',
    restockPeriodSalesByAlgorithm = 'Restock Period Sales by Algorithm',
    restockPeriodSalesBySalesObj = 'Restock Period Sales by Sales Obj',
    salesPeriodSalesByAlgorithm = 'Sales Period Sales by Algorithm',
    salesPeriodSalesBySalesObj = 'Sales Period Sales by Sales Obj',
}

export enum HeaderTipText {
    inTransitExplain = 'In transit Inventory for restocking',
    l1SalesExplain = 'Sales volume of last month',
    l1InStockDaysExplain = 'In-stock days of last month',
    l1DailySalesExplain = 'Average daily sales of last month',
    l2SalesExplain = 'Sales volume of two month ago',
    l2InStockDaysExplain = 'In-stock days of two month ago',
    l2DailySalesExplain = 'Average daily sales of two month ago',
    l3SalesExplain = 'Sales volume of three month ago',
    l3InStockDaysExplain = 'In-stock days of three month ago',
    l3DailySalesExplain = 'Average daily sales of three month ago',
    yoySalesExplain = 'Sales volume for the same sales period last year',
    yoyInStockDaysExplain = 'In-stock days for the same sales period last year',
    yoyDailySalesExplain = 'Average daily sales for the same sales period last year',
    r30SalesExplain = 'Sales volume of recent 30 days',
    r30InStockDaysExplain = 'in-stock days of recent 30 days',
    r30DailySalesExplain = 'Average daily sales of recent 30 days',
    r90SalesExplain = 'Sales volume of recent 90 days',
    r90InStockDaysExplain = 'in-stock days of recent 90 days',
    r90DailySalesExplain = 'Average daily sales of recent 90 days',
    r90VisitsExplain = 'Visits of recent 90 days',
    r90cvrExplain = 'Conversion rate of recent 90 days',
    AFSRExplain = 'After-sales rate',
    AFSRbySellerExplain = 'Seller responsibility after-sale reate',
}